export function generateCheckoutItemViewOfferCreditKey(
  itemView:
    App.Checkout.LEAccommodationItemView |
    App.Checkout.CruiseAccommodationItemView |
    App.Checkout.BedbankAccommodationItemView |
    App.Checkout.TourV2AccommodationItemView,
) {
  const params = new URLSearchParams({
    itemViewUniqueKey: itemView.uniqueKey,
    itemViewItemId: itemView.item.itemId,
  })
  return params.toString()
}
